import React, { useState } from "react";
import { useSpring, animated } from '@react-spring/web';

import { buildSafeAuthUrl, sanitizeUrl } from '../../utils/sanitize';
import imgDownload from "../../assets/img/whp-btn-download.svg";
import icoTK from "../../assets/img/whp-ico-tk.svg";
import icoWP from "../../assets/img/whp-ico-wp.svg";
import ShareTiktokComponent from "../shareTiktokComponent";

const VideoShareComponent = ({ videoCreated }) => {
    const siteUrl = `${window.location.origin}`;

    function shareOnWhatsApp() {
        const videoUrl = `${siteUrl}/videos/${videoCreated._id}`;
        const message = `¡Mira este video increíble que generé en el sitio! ${videoUrl}`;

        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, "_blank");
    }


    const [showTiktokForm, setShowTiktokForm] = useState(false);
    const shareOnTiktok = () => {
        setShowTiktokForm(true);
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Agrega desplazamiento suave
        });
    };
    const requestAutorizationTiktok = async (currentUrl) => {
        const safeUrl = buildSafeAuthUrl(
            process.env.REACT_APP_LAMBDA_ENDPOINT || '',
            process.env.REACT_APP_TIKTOK_REDIRECT || '',
            currentUrl || ''
        );

        if (safeUrl) {
            window.location.href = safeUrl;
        }
    };

    const handleDownload = (e) => {
    e.preventDefault(); // Evita que el navegador intente navegar

    if (videoCreated.preSignedURL) {
        const safeUrl = sanitizeUrl(videoCreated.preSignedURL, { allowData: false });
        if (safeUrl) {
            window.open(safeUrl, '_blank', 'noopener,noreferrer');
        }
    } 
    else if (videoCreated.base64Video) {
        // Solución de rendimiento y seguridad para Base64 usando Blob
        try {
            // Convertir el base64 a datos binarios (fuera del DOM)
            const byteCharacters = atob(videoCreated.base64Video);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'video/mp4' });

            // Crear una URL temporal en memoria (muy ligera)
            const blobUrl = URL.createObjectURL(blob);

            // Descargar de forma programática
            const tempLink = document.createElement('a');
            tempLink.href = blobUrl;
            tempLink.download = 'video-dancing-washers.mp4'; // Nombre del archivo sugerido
            document.body.appendChild(tempLink);
            tempLink.click();

            // Limpiar la memoria
            document.body.removeChild(tempLink);
            URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Error al procesar el video Base64", error);
        }
    }
};

    const props = useSpring({
        opacity: 1,
        transform: `translateY(0%)`,
        from: { opacity: 0, transform: `translateY(100%)` },
    });
    return <>
        <div className="video-share-component mt-5 mt-md-0 mb-5 mb-md-0 text-center position-relative ">
            {/* <img src={imgSeparator} alt="Separador" className="my-3" /> */}
            <p>Tu lavadora baila el ritmo de</p>
            <h3 className="mb-3 px-5">{videoCreated.beat}</h3>
            <div className="shareContainer">
                <p className=''>
                    Descarga tu video y ponlo a bailar en tus redes sociales. O compártelo desde aquí.
                </p>

                <a href="#" onClick={handleDownload} title="Descargar Video">
                    <img src={imgDownload} alt="Descargar" />
                </a>
                <button className='btn btn-link' onClick={shareOnWhatsApp} >
                    <img src={icoWP} alt="Whatsapp" />
                </button>
                <button className="btn btn-link" onClick={shareOnTiktok} >
                    <img src={icoTK} alt="Tiktok" />
                </button>
            </div>

        </div>

        <div className="video-share-component--gallery d-none">
            <button className='btn btn-link' onClick={shareOnWhatsApp} >
                <img src={icoWP} alt="Whatsapp" />
            </button>
            <button className="btn btn-link" onClick={shareOnTiktok} >
                <img src={icoTK} alt="Tiktok" />
            </button>
        </div>

        {showTiktokForm && (
            <animated.div className="modalFormTiktok" style={props}>
                <ShareTiktokComponent
                    videoId={videoCreated._id}
                    onClose={() => setShowTiktokForm(false)}
                    reAuth={requestAutorizationTiktok}
                />
            </animated.div>
        )}
    </>
};

export default VideoShareComponent;